import React, { useContext, useState } from "react";
import axios from "axios";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import styles from "./Login.module.scss";
import NavContext from "../../context/NavContext";
//IMG
import logo from "../../pics/logo-hearingspace.png"; 
import audioAvecPatient from "../../pics/audio_avec_patient.png"; 
import animationLogin from "../../pics/animation_login.gif"; 

import LoaderLogin from "../../components/UiComponents/loader/LoaderLogin";
import ForgotPassword from "../../components/authentification/ForgotPassword";

export default function Login({ setRememberMe }) {
  const { loginUser, loaderLogin } = useContext(NavContext);
  const { t } = useTranslation();

  const [userMail, setUserMail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showForgot, setShowForgot] = useState(false);

  axios.defaults.withCredentials = true;

  const submitForms = async (e) => {
    e.preventDefault();
    await loginUser(userMail, userPassword);
  };

  return (
    <div className={styles.loginPage}>
       {!showForgot && (
        <>
      <h1 className={styles.titleOne}>{t("login.title")}</h1>
      <img src={logo} alt="Logo" className={styles.logo} />
      <header className={styles.header}>
 
      </header>


     
          <div className={styles.heroSection}>
          <div className={styles.leftSide}>
            <h2 className={styles.title}>{t("login.welcome")}</h2>
            <form className={styles.loginForm} onSubmit={submitForms}>
              <div className={styles.formGroup}>
                <label htmlFor="email">{t("login.email_label")}</label>
                <input
                  type="text"
                  id="email"
                  placeholder="User name / Email"
                  value={userMail}
                  onChange={(e) => setUserMail(e.target.value)}
                  required
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="password">{t("login.password_label")}</label>
                <div className={styles.passwordWrapper}>
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    placeholder={t("login.password_placeholder")}
                    value={userPassword}
                    onChange={(e) => setUserPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className={`${styles.togglePassword} has-tooltip`}
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? t("login.hide_password") : t("login.show_password")}
                  >
                    {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                  </button>
                </div>
              </div>

              <button type="submit" className={styles.btnPrimary}>
                {t("login.submit")}
              </button>

              {loaderLogin && <LoaderLogin />}

              <div
                className={styles.forgot}
                onClick={() => setShowForgot(true)}
              >
                {t("login.forgot_password")}
 
              </div>
            </form>
          </div>
          <div className={styles.rightSide}>
            <img
              src={audioAvecPatient}
              alt={t("login.cabine_alt")}
              className={styles.heroImage}
            />
       
     
          </div>
        </div>
           </>)}
 
      {showForgot && (
        <ForgotPassword  showForgot={showForgot} setShowForgot={setShowForgot} />
      )}
    </div>
  );
}
